import React, { useState } from 'react';

const currentYear = new Date().getFullYear();
// Show current year back to 2020
const YEARS = Array.from({ length: currentYear - 2019 }, (_, i) => currentYear - i);
const todayIso = new Date().toISOString().split('T')[0];

const LABEL = { fontSize: 10, fontWeight: 600, color: 'var(--gray-500)', marginBottom: 4 };

// Detect if an ISO start date looks like the start of a known year
function detectMode(startIso) {
  if (!startIso) return String(currentYear);
  const parts = startIso.split('-');
  if (parts.length === 3 && parts[1] === '01' && parts[2] === '01') {
    const yr = Number(parts[0]);
    if (YEARS.includes(yr)) return String(yr);
  }
  return 'custom';
}

/**
 * DateRangeFilter
 *
 * Renders a "PERIOD" year-select + optional custom FROM/TO date pickers.
 * Fits inline in a flex filter row alongside other inputs.
 *
 * Props:
 *   start    — ISO date string (YYYY-MM-DD)
 *   end      — ISO date string (YYYY-MM-DD)
 *   onChange — (startIso, endIso) => void
 */
export default function DateRangeFilter({ start, end, onChange }) {
  const [mode, setMode] = useState(() => detectMode(start));

  const handleModeChange = (val) => {
    setMode(val);
    if (val === 'custom') return; // wait for user to pick dates
    const year = Number(val);
    const startIso = `${year}-01-01`;
    const endIso = year === currentYear ? todayIso : `${year}-12-31`;
    onChange(startIso, endIso);
  };

  return (
    <>
      <div>
        <div style={LABEL}>PERIOD</div>
        <select
          value={mode}
          onChange={e => handleModeChange(e.target.value)}
          className="form-select"
          style={{ fontSize: 11 }}
        >
          {YEARS.map(y => (
            <option key={y} value={String(y)}>{y}</option>
          ))}
          <option value="custom">Custom Range</option>
        </select>
      </div>

      {mode === 'custom' && (
        <>
          <div>
            <div style={LABEL}>FROM</div>
            <input
              type="date"
              value={start}
              onChange={e => onChange(e.target.value, end)}
              className="form-input"
              style={{ fontSize: 11 }}
            />
          </div>
          <div>
            <div style={LABEL}>TO</div>
            <input
              type="date"
              value={end}
              onChange={e => onChange(start, e.target.value)}
              className="form-input"
              style={{ fontSize: 11 }}
            />
          </div>
        </>
      )}
    </>
  );
}
